import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <section>
            <h2>1. Introduction</h2>
            <p>
              Any Edge (Pvt) Ltd ("we," "our," or "us") operates the vCard digital business card platform. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you use our service.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We collect information that you provide directly to us, including:</p>
            <ul>
              <li>Name, email address, and contact information</li>
              <li>Profile images and business information</li>
              <li>Payment information (processed securely through PayHere)</li>
              <li>Social media links and contact details</li>
              <li>Services, products, and brochure content</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>We automatically collect certain information when you use our service:</p>
            <ul>
              <li>Device information and IP address</li>
              <li>Browser type and version</li>
              <li>Usage data and analytics</li>
              <li>QR code scan statistics</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for:</p>
            <ul>
              <li>Providing and maintaining our service</li>
              <li>Processing payments and managing subscriptions</li>
              <li>Personalizing your vCard experience</li>
              <li>Sending service-related communications</li>
              <li>Analyzing usage patterns to improve our service</li>
              <li>Complying with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Storage and Security</h2>
            <p>
              Your data is stored securely using industry-standard encryption and security measures. 
              We use AWS S3 for file storage and MongoDB for database storage. While we implement 
              reasonable security measures, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2>5. Data Sharing and Disclosure</h2>
            <p>We do not sell your personal information. We may share your information only in the following circumstances:</p>
            <ul>
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent fraud</li>
              <li>With service providers who assist in operating our platform (e.g., payment processors, cloud storage)</li>
            </ul>
          </section>

          <section>
            <h2>6. Public vCard Information</h2>
            <p>
              Information you include in your public vCard (accessible via QR code) is publicly visible 
              to anyone who scans your QR code or accesses your vCard URL. This includes your name, 
              contact information, services, and any other content you choose to display.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and update your personal information</li>
              <li>Delete your account and associated data</li>
              <li>Opt-out of marketing communications</li>
              <li>Request a copy of your data</li>
            </ul>
          </section>

          <section>
            <h2>8. Cookies and Tracking</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our service and 
              store certain information. You can instruct your browser to refuse all cookies or to 
              indicate when a cookie is being sent.
            </p>
          </section>

          <section>
            <h2>9. Third-Party Services</h2>
            <p>
              Our service may contain links to third-party websites or services. We are not responsible 
              for the privacy practices of these third parties. We encourage you to read their privacy policies.
            </p>
          </section>

          <section>
            <h2>10. Children's Privacy</h2>
            <p>
              Our service is not intended for individuals under the age of 18. We do not knowingly 
              collect personal information from children.
            </p>
          </section>

          <section>
            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>12. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p>
              <strong>Any Edge (Pvt) Ltd</strong><br />
              Email: support@vcardapps.com<br />
              Website: www.vcardapps.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
